import ZkSubmenu from '../menu/src/submenu';

/* istanbul ignore next */
ZkSubmenu.install = function(Vue) {
  Vue.component(ZkSubmenu.name, ZkSubmenu);
};

export default ZkSubmenu;



// WEBPACK FOOTER //
// ./src/packages/submenu/index.js